// @flow
import type { TextProps } from './Text';
import type { Theme } from '../themes/types';
import Text from './Text';
import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'react-fela';

const Heading = (props: TextProps) => {
  const {
    bold = true,
    fontFamily = props.theme.heading.fontFamily,
    marginBottom = props.theme.heading.marginBottom,
    ...restProps
  } = props;
  return <Text bold={bold} fontFamily={fontFamily} marginBottom={marginBottom} {...restProps} />;
};

Heading.contextTypes = {
  theme: PropTypes.object,
};

export default withTheme(Heading, 'theme');
